import { useEffect, useState } from 'react'
import { checkSnooze } from '../../../helpers/checkSnooze'
import { setPersistedState } from '../../../state/Slices/persistedSlice'
import { useAppDispatch, useAppSelector } from '../../../state/hooks'

export const useCheckRestaurantSnoozed = rId => {
	const dispatch = useAppDispatch()
	const { loadedData } = useAppSelector(state => state.data)
	const [isRestaurantSnoozed, setIsRestaurantSnoozed] = useState(false)

	useEffect(() => {
		if (!global.kiosk) {
			dispatch(setPersistedState({ activeRID: rId }))
		}

		if (!!rId) {
			setIsRestaurantSnoozed(checkSnooze(loadedData[rId]?.isSnoozed, loadedData[rId]?.snoozeUntil))
		}
	}, [loadedData[rId], global.kiosk])

	return { isRestaurantSnoozed }
}
